import { supabase, isSupabaseConfigured } from "../../lib/supabaseClient";

function requireClient() {
  if (!supabase) throw new Error("Supabase is not configured.");
  return supabase;
}

export async function upsertPushSubscription(userId, subscription, userAgent) {
  const json = subscription.toJSON();
  const keys = json.keys || {};
  const endpoint = json.endpoint;
  const uid = String(userId);

  const client = requireClient();

  // One device endpoint → one user. Clear leftovers from other accounts on this phone.
  await client.from("push_subscriptions").delete().eq("endpoint", endpoint).neq("user_id", uid);

  const { error } = await client.from("push_subscriptions").upsert(
    {
      user_id: uid,
      endpoint,
      p256dh: keys.p256dh,
      auth: keys.auth,
      user_agent: userAgent || null,
      updated_at: new Date().toISOString(),
    },
    { onConflict: "user_id,endpoint" }
  );

  if (error) throw error;
}

export async function removePushSubscription(userId, endpoint) {
  const { error } = await requireClient()
    .from("push_subscriptions")
    .delete()
    .eq("user_id", String(userId))
    .eq("endpoint", endpoint);
  if (error) throw error;
}

export async function removeAllPushSubscriptions(userId) {
  const { error } = await requireClient()
    .from("push_subscriptions")
    .delete()
    .eq("user_id", String(userId));
  if (error) throw error;
}

export async function updatePushPresence(userId, endpoint) {
  if (!userId || !endpoint) return;
  const { error } = await requireClient()
    .from("push_subscriptions")
    .update({ last_active_at: new Date().toISOString() })
    .eq("user_id", String(userId))
    .eq("endpoint", endpoint);
  if (error) throw error;
}

export function isPushConfigured() {
  return isSupabaseConfigured && Boolean(process.env.REACT_APP_VAPID_PUBLIC_KEY);
}
